import { Component } from "@angular/core";
import {
	NavController,
	NavParams,
	ViewController,
	App,
	Platform,
	Events
} from "ionic-angular";

import { AddOrderServiceProvider } from "./../../pages/addorder/add-order.service";

import { APIServiceProvider } from "./../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";

@Component({
	selector: "modal-crop",
	templateUrl: "./modal-crop.html"
})
export class CropModalPage {
	list_crops: any = [];
	requestIndex: any = null;

	constructor(
		public navCtrl: NavController,
		public viewCtrl: ViewController,
		public platform: Platform,
		public app: App,
		public events: Events,
		public addOrderService: AddOrderServiceProvider,
		public helperService: HelperServiceProvider,
		public apiService: APIServiceProvider,
		public navParams: NavParams
	) {
		this.requestIndex = navParams.get("index");
	}

	dismiss() {
		this.viewCtrl.dismiss();
	}

	ionViewDidLoad() {
		this.getCrops();

		this.handelBackButton();
	}

	handelBackButton() {}

	getCrops() {
		this.apiService.get("categories/get-all-crops").subscribe(response => {
			this.list_crops = response["data"];
		});
	}

	selectCrop(crop) {
		crop.requestIndex = this.requestIndex;
		this.events.publish("selected-crop", crop);
		this.dismiss();
	}

	onClear(ev: any) {
		this.getCrops();
		ev.stopPropagation();
	}

	onCancel(ev: any) {
		this.getCrops();
	}

	filterCrop(ev: any) {
		let val = ev.target.value;

		if (typeof val === "undefined") {
			return;
		}

		this.list_crops = this.list_crops.filter(item => {
			return (
				item.category_name.toLowerCase().indexOf(val.toLowerCase()) > -1
			);
		});
	}
}
	



// WEBPACK FOOTER //
// ./src/modals/crop/crop.modal.ts